import { makeEventListener } from "@solid-primitives/event-listener";
import type { GenericSchema, InferOutput } from "valibot";
import { safeParse } from "valibot";

export const makeWindowEventListener = <TSchema extends GenericSchema>(
  sourceWindow: () => Window | null,
  schema: TSchema,
  handler: (event: InferOutput<TSchema>) => void,
) => {
  makeEventListener(globalThis.window, "message", (e: MessageEvent<unknown>) => {
    if (e.source !== sourceWindow()) {
      // Prevent "message spoofing", as `window` receives message events from all sources, including other iframes, browser extensions, or malicious third-party scripts.
      return;
    }
    if (typeof e.data !== "string") {
      throw new TypeError(`Received invalid window event: payload should be a string, received '${typeof e.data}'`);
    }

    let data: unknown;
    try {
      data = JSON.parse(e.data);
    } catch {
      // If it's not a valid JSON string, it might still be a plain string that the schema can handle
      data = e.data;
    }

    const result = safeParse(schema, data);
    if (result.success) {
      handler(result.output);
    }
  });
};
